import { render, staticRenderFns } from "./VirtualEventOption.vue?vue&type=template&id=2c0d6791"
import script from "./VirtualEventOption.vue?vue&type=script&lang=js"
export * from "./VirtualEventOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports